import { createSlice } from "@reduxjs/toolkit"

const locationReducer = createSlice({
  name: "location",
  initialState: {
    location: null,
  },
  reducers: {
    setLocation: (state, action) => {
      state.location = action.payload
    },
    clearLocation: (state) => {
      state.location = null
    },
  },
})

export const { setLocation, clearLocation } = locationReducer.actions
export default locationReducer.reducer
